import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ComingSoon from './pages/ComingSoon/ComingSoon.tsx'

// Set VITE_COMING_SOON=true on an environment to serve the holding page there.
// Vercel scopes env vars per environment, so Production can hold while Preview
// keeps serving the real site to work against.
const COMING_SOON = import.meta.env.VITE_COMING_SOON === 'true'

// Scrolling tab title when tab is not active
;(() => {
  const originalTitle = document.title
  const separator = '       '
  const scrollText = originalTitle + separator
  let intervalId: number | null = null
  let offset = 0

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      offset = 0
      intervalId = window.setInterval(() => {
        document.title = scrollText.slice(offset) + scrollText.slice(0, offset)
        offset = (offset + 1) % scrollText.length
      }, 100)
    } else {
      if (intervalId !== null) {
        clearInterval(intervalId)
        intervalId = null
      }
      document.title = originalTitle
    }
  })
})()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {COMING_SOON ? <ComingSoon /> : <App />}
  </StrictMode>,
)
